// extracted by mini-css-extract-plugin
module.exports = {"Header":"ArchiveListPage_Header__38gns","List":"ArchiveListPage_List__214K4","ListSkeleton":"ArchiveListPage_ListSkeleton__FgpGs"};